import { lazy } from 'react';
import { createRoute } from '@tanstack/react-router';
import { rootRoute } from './__root';

// Code splitting: Lazy load LoginPage to reduce initial bundle size
const LoginPage = lazy(() => import('@/pages/LoginPage'));

export const loginRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/login',
  component: LoginPage,
});

// 後方互換性のため
export const Route = loginRoute;
